declare let require: any;

export const environment = {
    production: true,
    version: require("../../package.json").version,
    api_tokens: {
        sentry: "https://3cec14e09b7b494693be2a2ef86cc5ac@sentry.io/66160",
        application_insights: "a1fbf994-553c-40ce-9266-fcd0b43fad1f",
    },
    api_url: "/api/",
    api_version: "v2/",
};
